/** Single money formatter so the same order never shows two formats. */

export function formatMoney(
  value: string | number | null | undefined,
  currency = "MXN",
): string {
  const amount = Number(value ?? 0);
  const safe = Number.isFinite(amount) ? amount : 0;
  // Centavos solo cuando existen: "$850" sigue igual, pero la comisión de
  // Mercado Pago "$39.07" ya no se redondea a "$39" (Eduardo 2026-09-07).
  const hasCents = Math.abs(safe - Math.round(safe)) >= 0.005;
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency,
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(safe);
}
